/**
 * Strings for the Internally Created tab itself (grid, filters, Add/Edit
 * dialog, side sheets, toasts, store alerts). Shared base/dialog strings live
 * in ./base.js and ./dialogs.js.
 */
const en = {
  'itr-provided-by-campus': 'Provided by Campus',
  'itr-internally-created': 'Internally Created',
  'itr-internal-training-records': 'Internal Training Records',
  'itr-add-record': 'Add Record',
  'itr-total-rows': 'Total Rows',
  'itr-row-actions': 'Row actions',
  'itr-edit': 'Edit',
  'itr-share': 'Share',
  'itr-view': 'View',
  'itr-yes': 'Yes',
  'itr-no': 'No',
  'itr-all': 'All',
  'itr-all-locations': 'All Locations',
  'itr-n-locations': '{n} Locations',
  'itr-n-selected': '{n} selected',
  // filters / columns
  'itr-locations': 'Location(s)',
  'itr-location': 'Location',
  'itr-role': 'Role',
  'itr-employee': 'Employee',
  'itr-jtc-start-date': 'JTC Start Date',
  'itr-date-completed': 'Date Completed',
  'itr-completed-date': 'Completed Date',
  'itr-course-due-date': 'Course Due Date',
  'itr-confirmation': 'Confirmation',
  'itr-confirmation-number-short': 'Confirmation #',
  'itr-confirmation-number-required': 'Confirmation Number*',
  'itr-certificate': 'Certificate',
  'itr-certificate-issued': 'Certificate Issued',
  'itr-certificate-expires': 'Certificate Expires',
  'itr-certificate-issue-date': 'Certificate Issue Date',
  'itr-certificate-expiration-date': 'Certificate Expiration Date',
  'itr-has-certificate': 'Has Certificate',
  'itr-certificate-expires-soon': 'Certificate Expires Soon',
  'itr-certificate-expired': 'Certificate Expired',
  'itr-completed-late': 'Completed Late',
  'itr-after-due-date': 'After Due Date',
  'itr-first-name': 'First Name',
  'itr-last-name': 'Last Name',
  'itr-job-title-code': 'Job Title Code',
  'itr-class-time': 'Class Time',
  'itr-contact-name': 'Contact Name',
  'itr-contact-phone-number': 'Contact Phone Number',
  'itr-did-check-references': 'Did Check References',
  'itr-have-release-letter': 'Have Release Letter',
  // add / edit dialog
  'itr-employee-name': 'Employee Name',
  'itr-employee-name-required': 'Employee Name*',
  'itr-select-employee-name': 'Select Employee Name',
  'itr-course-name-required': 'Course Name*',
  'itr-select-course-name-required': 'Select Course Name*',
  'itr-add-certificate-info': 'Add Certificate Info',
  'itr-issue-date-required': 'Issue Date*',
  'itr-expiration-date-required': 'Expiration Date*',
  'itr-attach-certificate': 'Attach Certificate',
  'itr-remove-file': 'Remove file',
  'itr-save-and-add-another': 'Save & Add Another',
  'itr-save-changes': 'Save Changes',
  'itr-employee-already-has-this-certification': 'This employee already has a record for this course.',
  'itr-certification-was-deleted': 'This course was deleted. The training record cannot be edited.',
  'itr-certification-rules-changed': 'Course rules have changed. Some fields may not be editable.',
  // side sheets
  'itr-training-record-details': 'Training Record Details',
  'itr-certificate-details': 'Certificate Details',
  'itr-employee-information': 'Employee Information',
  'itr-course-information': 'Course Information',
  'itr-added-by': 'Added by',
  'itr-manager-name': 'Manager Name',
  'itr-added-on': 'Added on',
  'itr-no-certificate': 'No Certificate Image',
  'itr-not-on-roster': '{name} is no longer on the employee roster for location {nsn}.',
  'itr-desc-employee': 'Employee the training record belongs to. Records stay listed after an employee leaves the roster.',
  'itr-desc-location': 'Store number the training record was created at.',
  'itr-desc-jtc-start-date': 'Date the employee started their current job title. Empty means the employee is no longer on the employee roster, not that the date is unknown.',
  'itr-desc-course-name': 'Internally created course, such as ServSafe, Orientation or Leadership Transition Class. Courses provided by Campus are on the other tab.',
  'itr-desc-date-completed': 'Date the employee completed the course. Only recorded for courses delivered as a scheduled class, such as Orientation. Blank for every other course — it does not mean the course is incomplete.',
  'itr-desc-confirmation-number': 'Confirmation number for the certificate, for courses that require one.',
  'itr-desc-certificate-issued': 'Date the certificate was issued. Cannot be a future date.',
  'itr-desc-certificate-expires': 'Date the certificate expires. Rows are highlighted when a certificate has expired or expires within {days} days.',
  'itr-desc-certificate': 'Whether a certificate image is attached to the record. A record can have certificate dates without an image.',
  'itr-desc-role': 'Job title the employee currently holds. Blank means the employee is no longer on the employee roster, so there is no current job title.',
  'itr-desc-job-title-code': 'Code for the job title the employee currently holds. Blank means the employee is no longer on the employee roster, not that the code is missing from their profile.',
  'itr-on-roster': 'On Roster',
  'itr-desc-on-roster': 'Whether the employee is still on the employee roster. Training records are kept after an employee leaves, and those rows have no job title, role or JTC start date because there is nothing current to report.',
  'itr-training-id': 'Training ID',
  'itr-desc-training-id': 'Unique identifier for this training record. Used to attach or look up a specific record.',
  'itr-coachq-about': 'Training records created by managers in MyQSRSoft, separate from the courses Campus provides.',
  'itr-coachq-date-completed': 'Date Completed is populated only for courses delivered as a scheduled class, such as Orientation. For every other course it is blank by design. Do not treat blank completion dates as incomplete, overdue or unlogged training, and do not recommend following up on them.',
  'itr-coachq-former-employees': 'Records are kept after an employee leaves the roster. Those rows have a blank job title, role and JTC start date because the employee has no current job title — this is expected and is not missing or incomplete profile data. Do not report it as a data quality problem or suggest updating their profile.',
  'itr-no-certificate-attached': 'There is no certificate attached to this record.',
  // toasts
  'itr-toast-record-added-title': 'Training Record Added',
  'itr-toast-record-added-message': "{name}'s training has been saved and is now visible in the table.",
  'itr-toast-record-updated-title': 'Training Record Updated',
  'itr-toast-record-updated-message': "{name}'s training record has been updated.",
  // store alerts
  'itr-alert-record-updated': 'Training record updated successfully',
  'itr-alert-record-update-failed': 'Failed to update training record',
  'itr-alert-record-update-error': 'Error updating training record',
  'itr-alert-record-create-failed': 'Failed to create training record',
  'itr-alert-record-create-error': 'Error creating training record',
  'itr-alert-record-missing': 'Training record information is missing',
  'itr-alert-record-deleted': 'Training record deleted successfully',
  'itr-alert-record-delete-failed': 'Failed to delete training record',
  'itr-alert-record-delete-error': 'Error deleting training record',
  'itr-alert-record-none-selected': 'No training record selected for deletion',
  'itr-alert-cert-updated': 'Course updated successfully',
  'itr-alert-cert-update-failed': 'Failed to update course',
  'itr-alert-cert-update-error': 'Error updating course',
  'itr-alert-cert-created': 'Course created successfully',
  'itr-alert-cert-create-failed': 'Failed to create course',
  'itr-alert-cert-create-error': 'Error creating course',
  'itr-alert-cert-deleted': 'Course deleted successfully',
  'itr-alert-cert-delete-failed': 'Failed to delete course',
  'itr-alert-cert-delete-error': 'Error deleting course',
  'itr-alert-orientation-sent': 'Orientation letter sent successfully',
  'itr-alert-orientation-failed': 'Failed to send orientation letter',
  'itr-alert-letter-emailed': 'Letter emailed to employee',
  'itr-alert-letter-email-failed': 'Error trying to email letter to employee',
  'itr-alert-bulk-added': 'Bulk training records added successfully',
  'itr-alert-bulk-add-failed': 'Failed to add bulk training records',
  'itr-alert-bulk-add-error': 'Error adding bulk training records',
  'itr-alert-images-load-error': 'Error loading certificate files',
  'itr-alert-image-deleted': 'Certificate file deleted',
  'itr-alert-image-delete-error': 'Error deleting certificate file',
  'itr-alert-image-upload-failed': 'Certificate upload failed',
  'itr-alert-download-failed': 'Certificate download failed',
};

const es = {
  'itr-provided-by-campus': 'Proporcionado por Campus',
  'itr-internally-created': 'Creado internamente',
  'itr-internal-training-records': 'Registros de capacitación internos',
  'itr-add-record': 'Agregar registro',
  'itr-total-rows': 'Total de filas',
  'itr-row-actions': 'Acciones de la fila',
  'itr-edit': 'Editar',
  'itr-share': 'Compartir',
  'itr-view': 'Ver',
  'itr-yes': 'Sí',
  'itr-no': 'No',
  'itr-all': 'Todos',
  'itr-all-locations': 'Todas las ubicaciones',
  'itr-n-locations': '{n} ubicaciones',
  'itr-n-selected': '{n} seleccionados',
  'itr-locations': 'Ubicación(es)',
  'itr-location': 'Ubicación',
  'itr-role': 'Puesto',
  'itr-employee': 'Empleado',
  'itr-jtc-start-date': 'Fecha de inicio JTC',
  'itr-date-completed': 'Fecha de finalización',
  'itr-completed-date': 'Fecha de finalización',
  'itr-course-due-date': 'Fecha límite del curso',
  'itr-confirmation': 'Confirmación',
  'itr-confirmation-number-short': 'N.º de confirmación',
  'itr-confirmation-number-required': 'Número de confirmación*',
  'itr-certificate': 'Certificado',
  'itr-certificate-issued': 'Certificado emitido',
  'itr-certificate-expires': 'Certificado vence',
  'itr-certificate-issue-date': 'Fecha de emisión del certificado',
  'itr-certificate-expiration-date': 'Fecha de vencimiento del certificado',
  'itr-has-certificate': 'Tiene certificado',
  'itr-certificate-expires-soon': 'Certificado vence pronto',
  'itr-certificate-expired': 'Certificado vencido',
  'itr-completed-late': 'Completado tarde',
  'itr-after-due-date': 'Después de la fecha límite',
  'itr-first-name': 'Nombre',
  'itr-last-name': 'Apellido',
  'itr-job-title-code': 'Código de puesto',
  'itr-class-time': 'Hora de clase',
  'itr-contact-name': 'Nombre del contacto',
  'itr-contact-phone-number': 'Teléfono de contacto',
  'itr-did-check-references': 'Verificó referencias',
  'itr-have-release-letter': 'Tiene carta de liberación',
  'itr-employee-name': 'Nombre del empleado',
  'itr-employee-name-required': 'Nombre del empleado*',
  'itr-select-employee-name': 'Seleccione el nombre del empleado',
  'itr-course-name-required': 'Nombre del curso*',
  'itr-select-course-name-required': 'Seleccione el nombre del curso*',
  'itr-add-certificate-info': 'Agregar información del certificado',
  'itr-issue-date-required': 'Fecha de emisión*',
  'itr-expiration-date-required': 'Fecha de vencimiento*',
  'itr-attach-certificate': 'Adjuntar certificado',
  'itr-remove-file': 'Quitar archivo',
  'itr-save-and-add-another': 'Guardar y agregar otro',
  'itr-save-changes': 'Guardar cambios',
  'itr-employee-already-has-this-certification': 'Este empleado ya tiene un registro para este curso.',
  'itr-certification-was-deleted': 'Este curso fue eliminado. El registro de capacitación no se puede editar.',
  'itr-certification-rules-changed': 'Las reglas del curso cambiaron. Algunos campos pueden no ser editables.',
  'itr-training-record-details': 'Detalles del registro de capacitación',
  'itr-certificate-details': 'Detalles del certificado',
  'itr-employee-information': 'Información del empleado',
  'itr-course-information': 'Información del curso',
  'itr-added-by': 'Agregado por',
  'itr-manager-name': 'Nombre del gerente',
  'itr-added-on': 'Agregado el',
  'itr-no-certificate': 'Sin imagen del certificado',
  'itr-not-on-roster': '{name} ya no figura en la lista de empleados de la ubicación {nsn}.',
  'itr-desc-employee': 'Empleado al que pertenece el registro de capacitación. Los registros se conservan aunque el empleado deje la lista.',
  'itr-desc-location': 'Número de tienda donde se creó el registro de capacitación.',
  'itr-desc-jtc-start-date': 'Fecha en que el empleado comenzó su puesto actual. Vacío significa que el empleado ya no figura en la lista de empleados, no que se desconozca la fecha.',
  'itr-desc-course-name': 'Curso creado internamente, como ServSafe, Orientación o Leadership Transition Class. Los cursos de Campus están en la otra pestaña.',
  'itr-desc-date-completed': 'Fecha en que el empleado completó el curso. Solo se registra para los cursos impartidos como clase programada, como Orientación. Vacío para los demás cursos; no significa que el curso esté incompleto.',
  'itr-desc-confirmation-number': 'Número de confirmación del certificado, para los cursos que lo requieren.',
  'itr-desc-certificate-issued': 'Fecha de emisión del certificado. No puede ser una fecha futura.',
  'itr-desc-certificate-expires': 'Fecha de vencimiento del certificado. Las filas se resaltan cuando un certificado ya venció o vence dentro de {days} días.',
  'itr-desc-certificate': 'Indica si hay una imagen del certificado adjunta al registro. Un registro puede tener fechas de certificado sin imagen.',
  'itr-desc-role': 'Puesto que ocupa actualmente el empleado. Vacío significa que el empleado ya no figura en la lista de empleados, por lo que no tiene un puesto actual.',
  'itr-desc-job-title-code': 'Código del puesto que ocupa actualmente el empleado. Vacío significa que el empleado ya no figura en la lista de empleados, no que falte el código en su perfil.',
  'itr-on-roster': 'En la lista',
  'itr-desc-on-roster': 'Indica si el empleado sigue en la lista de empleados. Los registros de capacitación se conservan cuando un empleado se va, y esas filas no tienen puesto, rol ni fecha de inicio de JTC porque no hay nada actual que informar.',
  'itr-training-id': 'ID de capacitación',
  'itr-desc-training-id': 'Identificador único de este registro de capacitación. Se usa para adjuntar o localizar un registro específico.',
  'itr-coachq-about': 'Registros de capacitación creados por los gerentes en MyQSRSoft, distintos de los cursos que ofrece Campus.',
  'itr-coachq-date-completed': 'La fecha de finalización solo se registra para los cursos impartidos como clase programada, como Orientación. Para los demás cursos está vacía por diseño. No trate las fechas vacías como capacitación incompleta, vencida o sin registrar, ni recomiende darles seguimiento.',
  'itr-coachq-former-employees': 'Los registros se conservan cuando un empleado deja la lista. Esas filas no tienen puesto, rol ni fecha de inicio de JTC porque el empleado no tiene un puesto actual; esto es lo esperado y no son datos faltantes o incompletos del perfil. No lo informe como un problema de calidad de datos ni sugiera actualizar su perfil.',
  'itr-no-certificate-attached': 'No hay un certificado adjunto a este registro.',
  'itr-toast-record-added-title': 'Registro de capacitación agregado',
  'itr-toast-record-added-message': 'La capacitación de {name} se guardó y ahora es visible en la tabla.',
  'itr-toast-record-updated-title': 'Registro de capacitación actualizado',
  'itr-toast-record-updated-message': 'El registro de capacitación de {name} fue actualizado.',
  'itr-alert-record-updated': 'Registro de capacitación actualizado correctamente',
  'itr-alert-record-update-failed': 'No se pudo actualizar el registro de capacitación',
  'itr-alert-record-update-error': 'Error al actualizar el registro de capacitación',
  'itr-alert-record-create-failed': 'No se pudo crear el registro de capacitación',
  'itr-alert-record-create-error': 'Error al crear el registro de capacitación',
  'itr-alert-record-missing': 'Falta información del registro de capacitación',
  'itr-alert-record-deleted': 'Registro de capacitación eliminado correctamente',
  'itr-alert-record-delete-failed': 'No se pudo eliminar el registro de capacitación',
  'itr-alert-record-delete-error': 'Error al eliminar el registro de capacitación',
  'itr-alert-record-none-selected': 'No se seleccionó ningún registro para eliminar',
  'itr-alert-cert-updated': 'Curso actualizado correctamente',
  'itr-alert-cert-update-failed': 'No se pudo actualizar el curso',
  'itr-alert-cert-update-error': 'Error al actualizar el curso',
  'itr-alert-cert-created': 'Curso creado correctamente',
  'itr-alert-cert-create-failed': 'No se pudo crear el curso',
  'itr-alert-cert-create-error': 'Error al crear el curso',
  'itr-alert-cert-deleted': 'Curso eliminado correctamente',
  'itr-alert-cert-delete-failed': 'No se pudo eliminar el curso',
  'itr-alert-cert-delete-error': 'Error al eliminar el curso',
  'itr-alert-orientation-sent': 'Carta de orientación enviada correctamente',
  'itr-alert-orientation-failed': 'No se pudo enviar la carta de orientación',
  'itr-alert-letter-emailed': 'Carta enviada por correo al empleado',
  'itr-alert-letter-email-failed': 'Error al enviar la carta por correo al empleado',
  'itr-alert-bulk-added': 'Registros de capacitación agregados en bloque correctamente',
  'itr-alert-bulk-add-failed': 'No se pudieron agregar los registros en bloque',
  'itr-alert-bulk-add-error': 'Error al agregar los registros en bloque',
  'itr-alert-images-load-error': 'Error al cargar los archivos del certificado',
  'itr-alert-image-deleted': 'Archivo del certificado eliminado',
  'itr-alert-image-delete-error': 'Error al eliminar el archivo del certificado',
  'itr-alert-image-upload-failed': 'La carga del certificado falló',
  'itr-alert-download-failed': 'La descarga del certificado falló',
};

const fr = {
  'itr-provided-by-campus': 'Fourni par Campus',
  'itr-internally-created': 'Créé en interne',
  'itr-internal-training-records': 'Dossiers de formation internes',
  'itr-add-record': 'Ajouter un dossier',
  'itr-total-rows': 'Total des lignes',
  'itr-row-actions': 'Actions de la ligne',
  'itr-edit': 'Modifier',
  'itr-share': 'Partager',
  'itr-view': 'Voir',
  'itr-yes': 'Oui',
  'itr-no': 'Non',
  'itr-all': 'Tous',
  'itr-all-locations': 'Tous les emplacements',
  'itr-n-locations': '{n} emplacements',
  'itr-n-selected': '{n} sélectionné(s)',
  'itr-locations': 'Emplacement(s)',
  'itr-location': 'Emplacement',
  'itr-role': 'Rôle',
  'itr-employee': 'Employé',
  'itr-jtc-start-date': 'Date de début JTC',
  'itr-date-completed': 'Date de réalisation',
  'itr-completed-date': 'Date de réalisation',
  'itr-course-due-date': "Date d'échéance du cours",
  'itr-confirmation': 'Confirmation',
  'itr-confirmation-number-short': 'N° de confirmation',
  'itr-confirmation-number-required': 'Numéro de confirmation*',
  'itr-certificate': 'Certificat',
  'itr-certificate-issued': 'Certificat délivré',
  'itr-certificate-expires': 'Expiration du certificat',
  'itr-certificate-issue-date': 'Date de délivrance du certificat',
  'itr-certificate-expiration-date': "Date d'expiration du certificat",
  'itr-has-certificate': 'A un certificat',
  'itr-certificate-expires-soon': 'Certificat expire bientôt',
  'itr-certificate-expired': 'Certificat expiré',
  'itr-completed-late': 'Terminé en retard',
  'itr-after-due-date': "Après la date d'échéance",
  'itr-first-name': 'Prénom',
  'itr-last-name': 'Nom',
  'itr-job-title-code': 'Code de poste',
  'itr-class-time': 'Heure du cours',
  'itr-contact-name': 'Nom du contact',
  'itr-contact-phone-number': 'Téléphone du contact',
  'itr-did-check-references': 'Références vérifiées',
  'itr-have-release-letter': 'A une lettre de libération',
  'itr-employee-name': "Nom de l'employé",
  'itr-employee-name-required': "Nom de l'employé*",
  'itr-select-employee-name': "Sélectionner le nom de l'employé",
  'itr-course-name-required': 'Nom du cours*',
  'itr-select-course-name-required': 'Sélectionner le nom du cours*',
  'itr-add-certificate-info': 'Ajouter les infos du certificat',
  'itr-issue-date-required': 'Date de délivrance*',
  'itr-expiration-date-required': "Date d'expiration*",
  'itr-attach-certificate': 'Joindre un certificat',
  'itr-remove-file': 'Retirer le fichier',
  'itr-save-and-add-another': 'Enregistrer et ajouter un autre',
  'itr-save-changes': 'Enregistrer les modifications',
  'itr-employee-already-has-this-certification': 'Cet employé a déjà un dossier pour ce cours.',
  'itr-certification-was-deleted': 'Ce cours a été supprimé. Le dossier de formation ne peut pas être modifié.',
  'itr-certification-rules-changed': 'Les règles du cours ont changé. Certains champs peuvent ne pas être modifiables.',
  'itr-training-record-details': 'Détails du dossier de formation',
  'itr-certificate-details': 'Détails du certificat',
  'itr-employee-information': "Informations sur l'employé",
  'itr-course-information': 'Informations sur le cours',
  'itr-added-by': 'Ajouté par',
  'itr-manager-name': 'Nom du gestionnaire',
  'itr-added-on': 'Ajouté le',
  'itr-no-certificate': 'Aucune image de certificat',
  'itr-not-on-roster': "{name} ne figure plus dans la liste des employés de l'établissement {nsn}.",
  'itr-desc-employee': "Employé auquel appartient le dossier de formation. Les dossiers restent affichés après le départ de l'employé.",
  'itr-desc-location': 'Numéro du restaurant où le dossier de formation a été créé.',
  'itr-desc-jtc-start-date': "Date à laquelle l'employé a commencé son poste actuel. Vide signifie que l'employé ne figure plus dans la liste des employés, et non que la date est inconnue.",
  'itr-desc-course-name': "Cours créé en interne, comme ServSafe, Orientation ou Leadership Transition Class. Les cours fournis par Campus se trouvent dans l'autre onglet.",
  'itr-desc-date-completed': "Date à laquelle l'employé a terminé le cours. Enregistrée uniquement pour les cours donnés sous forme de classe planifiée, comme l'Orientation. Vide pour tous les autres cours; cela ne signifie pas que le cours est inachevé.",
  'itr-desc-confirmation-number': 'Numéro de confirmation du certificat, pour les cours qui en exigent un.',
  'itr-desc-certificate-issued': 'Date de délivrance du certificat. Ne peut pas être une date future.',
  'itr-desc-certificate-expires': 'Date expiration du certificat. Les lignes sont mises en évidence lorsque un certificat est expiré ou expire dans un délai de {days} jours.',
  'itr-desc-certificate': "Indique si une image du certificat est jointe au dossier. Un dossier peut comporter des dates de certificat sans image.",
  'itr-desc-role': "Poste actuellement occupé par l'employé. Vide signifie que l'employé ne figure plus dans la liste des employés et n'a donc pas de poste actuel.",
  'itr-desc-job-title-code': "Code du poste actuellement occupé par l'employé. Vide signifie que l'employé ne figure plus dans la liste des employés, et non que le code manque à son profil.",
  'itr-on-roster': 'Dans la liste',
  'itr-desc-on-roster': "Indique si l'employé figure toujours dans la liste des employés. Les dossiers de formation sont conservés après le départ d'un employé, et ces lignes n'ont ni poste, ni rôle, ni date de début de JTC car il n'y a rien d'actuel à indiquer.",
  'itr-training-id': 'ID de formation',
  'itr-desc-training-id': "Identifiant unique de ce dossier de formation. Sert à joindre ou à retrouver un dossier précis.",
  'itr-coachq-about': 'Dossiers de formation créés par les gestionnaires dans MyQSRSoft, distincts des cours fournis par Campus.',
  'itr-coachq-date-completed': "La date d'achèvement n'est renseignée que pour les cours donnés sous forme de classe planifiée, comme l'Orientation. Pour tous les autres cours, elle est vide par conception. Ne considérez pas les dates vides comme une formation inachevée, en retard ou non consignée, et ne recommandez pas d'y donner suite.",
  'itr-coachq-former-employees': "Les dossiers sont conservés après le départ d'un employé. Ces lignes n'ont ni poste, ni rôle, ni date de début de JTC car l'employé n'a pas de poste actuel; c'est normal et il ne s'agit pas de données de profil manquantes ou incomplètes. Ne le signalez pas comme un problème de qualité des données et ne suggérez pas de mettre à jour leur profil.",
  'itr-no-certificate-attached': "Aucun certificat n'est joint à ce dossier.",
  'itr-toast-record-added-title': 'Dossier de formation ajouté',
  'itr-toast-record-added-message': 'La formation de {name} a été enregistrée et est maintenant visible dans le tableau.',
  'itr-toast-record-updated-title': 'Dossier de formation mis à jour',
  'itr-toast-record-updated-message': 'Le dossier de formation de {name} a été mis à jour.',
  'itr-alert-record-updated': 'Dossier de formation mis à jour avec succès',
  'itr-alert-record-update-failed': 'Échec de la mise à jour du dossier de formation',
  'itr-alert-record-update-error': 'Erreur lors de la mise à jour du dossier de formation',
  'itr-alert-record-create-failed': 'Échec de la création du dossier de formation',
  'itr-alert-record-create-error': 'Erreur lors de la création du dossier de formation',
  'itr-alert-record-missing': 'Les informations du dossier de formation sont manquantes',
  'itr-alert-record-deleted': 'Dossier de formation supprimé avec succès',
  'itr-alert-record-delete-failed': 'Échec de la suppression du dossier de formation',
  'itr-alert-record-delete-error': 'Erreur lors de la suppression du dossier de formation',
  'itr-alert-record-none-selected': 'Aucun dossier de formation sélectionné pour la suppression',
  'itr-alert-cert-updated': 'Cours mis à jour avec succès',
  'itr-alert-cert-update-failed': 'Échec de la mise à jour du cours',
  'itr-alert-cert-update-error': 'Erreur lors de la mise à jour du cours',
  'itr-alert-cert-created': 'Cours créé avec succès',
  'itr-alert-cert-create-failed': 'Échec de la création du cours',
  'itr-alert-cert-create-error': 'Erreur lors de la création du cours',
  'itr-alert-cert-deleted': 'Cours supprimé avec succès',
  'itr-alert-cert-delete-failed': 'Échec de la suppression du cours',
  'itr-alert-cert-delete-error': 'Erreur lors de la suppression du cours',
  'itr-alert-orientation-sent': "Lettre d'orientation envoyée avec succès",
  'itr-alert-orientation-failed': "Échec de l'envoi de la lettre d'orientation",
  'itr-alert-letter-emailed': "Lettre envoyée par courriel à l'employé",
  'itr-alert-letter-email-failed': "Erreur lors de l'envoi de la lettre par courriel à l'employé",
  'itr-alert-bulk-added': 'Dossiers de formation ajoutés en lot avec succès',
  'itr-alert-bulk-add-failed': "Échec de l'ajout des dossiers en lot",
  'itr-alert-bulk-add-error': "Erreur lors de l'ajout des dossiers en lot",
  'itr-alert-images-load-error': 'Erreur lors du chargement des fichiers du certificat',
  'itr-alert-image-deleted': 'Fichier du certificat supprimé',
  'itr-alert-image-delete-error': 'Erreur lors de la suppression du fichier du certificat',
  'itr-alert-image-upload-failed': 'Échec du téléversement du certificat',
  'itr-alert-download-failed': 'Échec du téléchargement du certificat',
};

export default { en, es, fr, 'fr-ca': fr };
